<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.75" y="4.75" width="18.5" height="14.5" rx="2.25" :stroke="fill" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.5 12.5C9.03043 12.5 9.53914 12.2893 9.91421 11.9142C10.2893 11.5391 10.5 11.0304 10.5 10.5C10.5 9.96957 10.2893 9.46086 9.91421 9.08579C9.53914 8.71071 9.03043 8.5 8.5 8.5C7.96957 8.5 7.46086 8.71071 7.08579 9.08579C6.71071 9.46086 6.5 9.96957 6.5 10.5C6.5 11.0304 6.71071 11.5391 7.08579 11.9142C7.46086 12.2893 7.96957 12.5 8.5 12.5Z" :stroke="fill" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M11.5 15.5C11.5 14.7044 11.1839 13.9413 10.6213 13.3787C10.0587 12.8161 9.29565 12.5 8.5 12.5C7.70435 12.5 6.94129 12.8161 6.37868 13.3787C5.81607 13.9413 5.5 14.7044 5.5 15.5M14 10H18M15 14H18" :stroke="fill" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    width: {
      default: 24,
    },
    height: {
      default: 24,
    },
    fill: {
      default: "currentColor",
    },
    viewBox: {
      default: "0 0 24 24",
    },
    disabled: {
      default: false,
    },
  },
})
</script>
